import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";

import { SubscriptionOptions } from "../../../types/rtk/subscription/subscription";
import LogoSvg from "../../atoms/LogoSvg/LogoSvg";
import ActiveButton from "../../../assets/images/RADIO-BUTTON-ACTIVE.svg";
import InactiveButton from "../../../assets/images/RADIO-BUTTON-INACTIVE.svg";
import Chip from "../../atoms/Chip/Chip";
import Text from "../../atoms/Text/Text";
import { useAppDispatch, useAppSelector } from "../../../rtk/_config/hooks";
import { setBasket } from "../../../rtk/basket/basket";
import { RootState } from "../../../types/rtk/api-config/types";
import { formatPrice } from "../../../helpers/currencyHelper";

interface Props {
  data: SubscriptionOptions;
  index: number;
}

const OptionCard = ({ data, index }: Props) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const basket = useAppSelector((state: RootState) => state.basket);
  const isActive = basket.options?.includes(data.id) ?? false;

  const handleSetActive = () => {
    const currentOptions = basket.options ?? [];
    const isCurrentlyActive = currentOptions.includes(data.id);
    
    if (isCurrentlyActive) {
      const newOptions = currentOptions.filter(id => id !== data.id);
      dispatch(setBasket({ ...basket, options: newOptions }));
    } else {
      const newOptions = [...currentOptions, data.id];
      dispatch(setBasket({ ...basket, options: newOptions }));
    }
  };

  return (
    <>
      <Box
        className={`OptionCard ${isActive && "isOptionCardActive"}`}
        onClick={handleSetActive}
      >
        {data && data.code === "premium_pack" && (
          <Chip
            text={t("subscription:SECOND_PAGE.OPTION_CHOICE.CHIP")}
            isActive
          />
        )}
        <Box className="offer">
          <Box className="optionRadioButton">
            <LogoSvg src={isActive ? ActiveButton : InactiveButton} />
          </Box>
          <Box className="optionTitle">
            <Text
              className="bold"
              children={t(
                `subscription:SECOND_PAGE.OPTION_CHOICE.TITLE.${data.code}`
              )}
            />
          </Box>

          {data && (
            <Box className="optionPrice">
              {data && (
                <>
                  <Box className="prices">
                    <Text className="bold">
                      {`${formatPrice(data.price.amount / data.period, data.price.currency)}`}
                    </Text>
                    <Text className="bold">{` / ${t("subscription:MONTH")}`}</Text>
                  </Box>
                </>
              )}
            </Box>
          )}
        </Box>
        <Box className="text">
          <Text
            className="small"
            children={t(
              `subscription:SECOND_PAGE.OPTION_CHOICE.TEXT.${data.code}`
            )}
          />
        </Box>
      </Box>
    </>
  );
};

export default OptionCard;
